import { Map } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FORCE_CONNECT_SOCKET,
	FORCE_CONNECT_SOCKET_SUCCESS,

	START_FORCE_DISCONNECT_SOCKET,
	FORCE_DISCONNECT_SOCKET_SUCCESS,

	START_FORCE_RECONNECT_SOCKET,
	FORCE_RECONNECT_SOCKET_SUCCESS,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
} = LoadingStatusEnum;
const initialState = Map({
	disconnectType: '',

	connectSocketLoadingStatus: NONE,

	disconnectSocketLoadingStatus: NONE,

	isReconnecting: false,
});

export default function application(state = initialState, action) {
	switch (action.type) {
		case START_FORCE_CONNECT_SOCKET:
			return state
				.set('connectSocketLoadingStatus', LOADING);

		case FORCE_CONNECT_SOCKET_SUCCESS:
			return state
				.set('disconnectType', '')
				.set('connectSocketLoadingStatus', SUCCESS);

		case START_FORCE_DISCONNECT_SOCKET:
			return state
				.set('disconnectSocketLoadingStatus', LOADING);

		case FORCE_DISCONNECT_SOCKET_SUCCESS:
			return state
				.set('disconnectType', action.disconnectType)
				.set('disconnectSocketLoadingStatus', SUCCESS);

		case START_FORCE_RECONNECT_SOCKET:
			return state
				.set('isReconnecting', true);

		case FORCE_RECONNECT_SOCKET_SUCCESS:
			return state
				.set('disconnectType', '')
				.set('isReconnecting', false);

		default:
			return state;
	}
}
